import React from "react";
import HiddenNav from "./HiddenNav";
import clsx from "clsx";
import { GridLegacy, IconButton, Tooltip } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { updateSection } from "../../Tools/Tools";
import SmetaBreadcrumbs from "./Breadcumbs";
import { useAtomValue } from "jotai";
import { currentTheme } from "../../../../atoms";
import styles from "./Header.module.css";

export default function SubHeader(props: any) {
  const theme = useAtomValue(currentTheme);
  // const currentUserInfo: any = get_cookie("LastLogin").split(",");

  return (
    <GridLegacy className={clsx(styles.SubHeader)} item>
      {/* boxShadow: "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)" */}
      <div id="miniMenu" className={clsx(styles.miniMenu)}>
        {/* <Grid container direction="row" justifyContent="flex-start" alignItems="center" > */}
        <HiddenNav drawerOpen={props.drawerOpen} />
        <div
          className={clsx(styles.subHeaderText, {
            [styles.SubHeaderPadding10]: props.drawerOpen,
            [styles.SubHeaderPadding0]: !props.drawerOpen,
          })}
          id="NameSection"
        >
          {/* {getName()} */}

          <SmetaBreadcrumbs />
        </div>
        <div id="refreshbuttonforall">
          <Tooltip title="Обновить секцию" placement="right">
            <IconButton
              style={{ padding: "8px" }}
              onClick={() => {
                updateSection();
              }}
            >
              <RefreshIcon className={clsx("iconButtonStimate", { light: theme === "light" })} fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </GridLegacy>
  );
}
